const E = " ", t = "Enter", n = [E, t];
export {
  n as COMBOBOX_SELECTION_KEYS,
  t as ENTER_KEY,
  E as SPACE_KEY
};
